<template>
  <v-card>
    <v-card-title>
      Outputs
      <v-spacer />
      <v-select
        v-model="selectedOutput"
        :items="availableToShow"
        item-text="key"
        item-value="value"
        label="Download options"
        outlined
        hide-details
        dense
      >
        <template #append-outer>
          <v-btn
            height="100%"
            outlined
            :disabled="!selectedOutput"
            :loading="connecting"
            @click="connect()"
          >
            <v-icon class="mx-0"> add </v-icon>
          </v-btn>
        </template>
      </v-select>
    </v-card-title>
    <v-divider />
    <v-card-text>
      <v-data-table
        disable-pagination
        hide-default-footer
        hide-default-header
        :headers="[
          { text: 'Name', value: 'name' },
          { text: '', value: 'actions' }
        ]"
        :items="connected"
      >
        <template #[`item.name`]="{ item }">
          {{ item.name }}
          <v-tooltip right>
            <template #activator="{ on, attrs }">
              <v-icon
                small
                v-bind="attrs"
                color="primary"
                class="ml-1"
                v-on="on"
              >
                info
              </v-icon>
            </template>
            <div class="tooltip-limit-width">
              {{ item.description }}
            </div>
          </v-tooltip>
          <v-btn
            v-if="!item.isDefaultPrint"
            small
            color="info"
            class="ml-2"
            @click="setDefaultPrint(item.id)"
          >
            set as default
          </v-btn>
        </template>
        <template #[`item.actions`]="{ item }">
          <v-icon
            color="primary"
            @click="disconnect(item.id)"
          >
            delete
          </v-icon>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ProductOutputs',
  data() {
    return {
      selectedOutput: null,
      disconnecting: false,
      connecting: false,
      settingDefault: false
    };
  },
  computed: {
    availableToShow() {
      return this.available.concat([{ key: '*** View all download options ***', value: 'link' }]);
    },
    ...mapGetters({
      product: 'products/product',
      connected: 'outputs/connected',
      available: 'outputs/available'
    })
  },
  watch: {
    selectedOutput(val) {
      if (val === 'link') {
        this.$router.push('/outputs');
      }
    }
  },
  methods: {
    async disconnect(outputId) {
      this.disconnecting = true;
      this.$store
        .dispatch('outputs/disconnect', {
          outputId,
          coreProductId: this.product.id
        })
        .then(() => {
          this.load();
          this.$root.$snackbarSuccess('Download option disconnected');
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.disconnecting = false;
        });
    },

    async connect() {
      this.connecting = true;
      this.$store
        .dispatch('outputs/connect', {
          outputId: this.selectedOutput,
          coreProductId: this.product.id
        })
        .then(() => {
          this.load();
          this.$root.$snackbarSuccess('Download option connected');
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.connecting = false;
        });
    },
    load() {
      this.$store.dispatch('outputs/getList', this.product.id);
    },
    setDefaultPrint(id) {
      this.settingDefault = true;
      this.$store
        .dispatch('outputs/setDefault', {
          outputId: id,
          coreProductId: this.product.id
        })
        .then(() => {
          this.load();
          this.$root.$snackbarSuccess('Default set');
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.settingDefault = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .v-input__append-outer {
  margin: 0 !important;
  margin-left: 10px !important;
  height: 40px;
}
</style>
